import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IPercentage } from '@vp/vp-js-token-engine';

export default class PercentOff extends React.Component<IPricePresentationBase<IPercentage>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="percentOff"
        pricingInfo={this.props.pricingInfo}
        placeHolderText={this.props.placeHolderText}
      />
    );
  }
}
